import { prepareFormDataId } from '@/utils/form/prepareFormDataId'

function prepareProjectEstimateFormData (data) {
  const keyList = [
    'mol',
    'base'
  ]

  data.base_type = data.base_type?.value

  return prepareFormDataId(data, keyList)
}

function prepareProjectOwnProductionFormData (data) {
  const keyList = [
    'surcharge_type',
    'type',
    'product_type'
  ]

  return prepareFormDataId(data, keyList)
}

export {
  prepareProjectEstimateFormData,
  prepareProjectOwnProductionFormData
}
